import React from 'react';
import {useLocation, useParams} from "react-router-dom";
import {useAuth} from "../../providers/AuthProvider";
import PageNotAllowed from "../../components/errors/PageNotAllowed";
import TalentApplication from "../talent-application/TalentApplication";
import {useQueryClient} from "@tanstack/react-query";
import LoadingBanner from "../../components/LoadingBanner";
import ErrorBanner from "../../components/ErrorBanner";
import ResourceNotFound from "../../components/errors/ResourceNotFound";
import {useAPI} from "../../config/API";
import User from "../../models/User";


const SupplierTalentProfileEdit = () => {

    const location = useLocation();
    const {talentUserId} = useParams();
    const {auth} = useAuth();
    const queryClient = useQueryClient()

    const {
        data: talentUser,
        isInitialLoading,
        isRefetching,
        refetch,
        error,
    } = useAPI(
        ['fetchSupplierTalentResource', talentUserId], {
            enabled: auth?.canManageClientResourceTalent() && auth?.hasSupplierClientOrg() && !TB.isNaN(parseInt(talentUserId)),
        }
    );

    if (auth && (!auth.canManageClientResourceTalent() || !auth.hasSupplierClientOrg())) {
        return <PageNotAllowed/>
    }

    if (isInitialLoading || isRefetching) {
        return (
            <div className="flex flex-col pt-8 items-center justify-center">
                <LoadingBanner message="Loading talent profile"/>
            </div>
        )
    }

    if (error) {
        return (
            <div className="flex flex-col pt-8 items-center justify-center">
                <ErrorBanner title="Something went wrong" message="Please try again later" onRetry={refetch}/>
            </div>
        )
    }
    if (!talentUser) {
        return <ResourceNotFound type="Talent Resource"/>
    }
    return (
        <TalentApplication
            user={talentUser}
            onUpdateTalent={async (props) => {

                let updatedTalentUser = User.make({...props, ...talentUser});
                await queryClient.setQueryData(['fetchSupplierTalentResource', talentUserId], updatedTalentUser)
                return updatedTalentUser;
            }}/>
    );
};

export default SupplierTalentProfileEdit;